import {BRAND_TYPES_CONSTS} from "../constants";

export const initialState = {
    brandTypesList: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case BRAND_TYPES_CONSTS.GET_BRAND_TYPES:
            return {
                ...state,
                brandTypesList: action.payload || [],
            };
        case BRAND_TYPES_CONSTS.CREATE_BRAND_TYPES:
            return {
                ...state,
                brandTypesList: [action.payload].concat(state.brandTypesList)
            };
        case BRAND_TYPES_CONSTS.UPDATE_BRAND_TYPES:
            return {
                ...state,
                brandTypesList: state.brandTypesList.map(item => item.id === action.payload.id
                    ? action.payload : item)
            };
        case BRAND_TYPES_CONSTS.DELETE_BRAND_TYPES_BY_ID:
            return {
                ...state,
                brandTypesList: state.brandTypesList.filter(item => item.id !== action.payload)
            };
        default:
            return state;
    }
}
